import { formatTime, formatDate } from '../../filter'
import moment from 'moment'

// 约定的数据字段结构
/**
 * 获取编辑数据
 * @returns {
    key: string; // 字段名称
    label: string; // 字段显示名
    value: string; // 字段当前值。枚举值时用英文逗号分隔。已经设值和默认值都可通过当前字段实现。当字段类型为下拉列表等时，要映射到枚举值的展示值
    type: string; // 字段类型
    notNull: string; // 是否必填。0-非必填，1-必填
    enumCode: string; // enumCode":"对应枚举code。当type为下拉列表/选框时用
    length?: number; // 字段长度限制。当type为文本输入框时用
    maxValue?: number; // 最大值。type为数字时用
    minValue?: number; // 最小值。type为数字时用
    canEdit?: boolean; // 自定义的是否可编辑
    selectOption: any[]; // 自定义的下拉选项
    rules?: any[]; // 支持自定义校验规则
    spacialLabelWidth?: number; // 支持自定义label宽度
    symbol?: string; // 输入框后面的单位或符号
    button?: string; // 输入框后面的按钮
    btnFun?: Function; // 输入框后面的按钮
    labelSpan?: Function; // label的栅格比例
    wrapperSpan?: Function; // 内容的栅格比例
	formSpan?: number; // 表单的栅格比例
}
 */
function getAge(birthday) {
	var birthdays = new Date(birthday.replace(/-/g, '/'))
	var d = new Date()
	var age =
		d.getFullYear() -
		birthdays.getFullYear() -
		(d.getMonth() < birthdays.getMonth() ||
		(d.getMonth() == birthdays.getMonth() && d.getDate() < birthdays.getDate())
			? 1
			: 0)
	return age
}
// 设置当前项的必填和可编辑
function setTableRequiredAndEditable(key, obj, notNull, canEdit) {
	// 对应值设置
	if (obj.key == key) {
		obj.notNull = notNull
		obj.canEdit = canEdit
	}
}
// 设置多行表单值
function setTableValue(key, obj, value) {
	if (obj.key == key) {
		obj.value = value
	}
}
export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this

	let familyInfoList = []
	if (injured.familyDto && injured.familyDto.familyInfoList.length) {
		familyInfoList = injured.familyDto.familyInfoList
	}

	const fatherDied = !(
		injured.familyDto && ['0', ''].includes(injured.familyDto.fatherDied)
	)

	const motherDied = !(
		injured.familyDto && ['0', ''].includes(injured.familyDto.motherDied)
	)

	const noChildren = !(
		injured.familyDto && ['0', ''].includes(injured.familyDto.noChildren)
	)

	const noOther = !(
		injured.familyDto && ['0', ''].includes(injured.familyDto.noOther)
	)

	const modal = [
		{
			label: '与伤者关系',
			value: '',
			key: 'dependType',
			selectOption: setting.dependentTypeList,
			type: 'select',
			notNull: '1',
			canEdit: true,
			formSpan: 3,
		},
		{
			label: '姓名',
			value: '',
			key: 'name',
			type: 'text',
			notNull: '1',
			canEdit: true,
			formSpan: 2,
			rules: [
				{
					max: 16,
					message: '长度不能超过16位',
					trigger: 'blur',
				},
			],
		},
		{
			label: '出生日期',
			value: '',
			key: 'birthday',
			type: 'date',
			notNull: '1',
			canEdit: true,
			allowClear: false,
			formSpan: 3,
			disabledDate: current => {
				// 不能大于今天
				return current && current > moment().endOf('day')
			}, //禁止选择的时间区间
		},
		{
			label: '抚养年限',
			value: '',
			key: 'dependYear',
			type: 'text',
			notNull: '0',
			canEdit: false,
			formSpan: 2,
		},
		{
			label: '户籍状态',
			value: '',
			key: 'censusRegisterType',
			selectOption: setting.censusRegisterTypeList,
			type: 'select',
			notNull: '1',
			canEdit: true,
			formSpan: 3,
		},
		{
			label: '性别',
			value: '',
			key: 'sex',
			selectOption: setting.sexList,
			type: 'select',
			notNull: '1',
			canEdit: true,
			formSpan: 2,
		},
		{
			label: '生育子女数',
			value: '',
			key: 'dependCount',
			type: 'text',
			notNull: '1',
			canEdit: true,
			formSpan: 3,
			rules: [
				{
					pattern: /^\d{0,2}$/,
					message: '长度不能超过2位',
					trigger: 'blur',
				},
			],
		},
		{
			label: '备注',
			value: '',
			key: 'remark',
			type: 'text',
			notNull: '0',
			canEdit: true,
			formSpan: 3,
			rules: [
				{
					max: 250,
					message: '长度不能超过250位',
					trigger: 'blur',
				},
			],
		},
		{
			label: '关系',
			value: '',
			key: 'fosterRelation',
			type: 'hide',
			notNull: '0',
			canEdit: false,
			formSpan: 3,
		},
	]

	const list = familyInfoList.map((item, index) => {
		let now = moment()
		let birthday = item.birthday
			? moment(formatDate(item.birthday), 'YYYY-MM-DD')
			: ''
		// 计算被抚养人年龄
		let injuredAge = 0
		if (birthday) {
			injuredAge = now.diff(birthday, 'years')
		}
		// 计算抚养年限
		let dependYear = ''
		if (injuredAge < 18) {
			dependYear = 18
		} else if (injuredAge >= 18 && injuredAge <= 60) {
			dependYear = 20
		} else if (injuredAge > 60 && injuredAge < 75) {
			dependYear = parseInt(80 - injuredAge)
		} else if (injuredAge >= 75) {
			dependYear = 5
		}
		const valArr = [
			item.dependType,
			item.name,
			birthday,
			dependYear,
			item.censusRegisterType,
			item.sex,
			item.dependCount,
			item.remark,
			item.fosterRelation,
		]

		let arr = modal.map((moadlItem, valIndex) => {
			let obj = {
				...moadlItem,
				value: valArr[valIndex],
			}
			let age = getAge(moment(item.birthday).format('YYYY-MM-DD'))
			if ((item.dependType == '04' || item.dependType == '05') && age < 58) {
				setTableRequiredAndEditable('name', obj, '0', true)
				setTableRequiredAndEditable('censusRegisterType', obj, '0', true)
				setTableRequiredAndEditable('dependCount', obj, '0', true)
			}
			if ((item.dependType == '04' || item.dependType == '05') && age >= 58) {
				setTableRequiredAndEditable('name', obj, '1', true)
				setTableRequiredAndEditable('censusRegisterType', obj, '1', true)
				setTableRequiredAndEditable('dependCount', obj, '1', true)
			}
			if (item.dependType == '06' && age > 18) {
				setTableRequiredAndEditable('name', obj, '0', true)
				setTableRequiredAndEditable('censusRegisterType', obj, '0', true)
			} else if (item.dependType == '06' && age <= 18) {
				setTableRequiredAndEditable('name', obj, '1', true)
				setTableRequiredAndEditable('censusRegisterType', obj, '1', true)
			}
			if (item.dependType == '06') {
				setTableValue('fosterRelation', obj, '子女')
			}
			if (item.dependType == '03') {
				setTableValue('fosterRelation', obj, '其他')
			}
			if (valIndex == 5) {
				// 关系为父、母时限制性别
				if (item.dependType == '04' || item.dependType == '05') {
					obj.canEdit = false
				}
			}
			if (valIndex == 6) {
				// 关系为配偶或子女或其他，生育子女数置灰
				if (item.dependType != '04' && item.dependType != '05') {
					obj.notNull = '0'
					obj.canEdit = false
				}
			}
			return obj
		})

		// 自定义模块
		let isCustomBtn = false
		// if (['04', '05', '06', '07'].includes(item.dependType)) {
		// 	isCustomBtn = true
		// 	arr[0].canEdit = false
		// }
		if (index == 0 || index == 1 || index == 2 || index == 3) {
			isCustomBtn = true
			arr[0].canEdit = false
		}
		// 一整行的可编辑性
		let disabled = false
		if (item.dependType == '04') {
			disabled = fatherDied
		}
		if (item.dependType == '05') {
			disabled = motherDied
		}
		if (item.dependType == '07') {
			disabled = ['0', '1', '2'].includes(injured.familyDto.partnerStatus)
		}
		if (item.dependType == '06') {
			disabled = noChildren
		}

		return {
			list: arr,
			isCustomBtn,
			dependType: item.dependType,
			disabled: disabled,
		}
	})

	let partnerStatus = ''
	if (injured.familyDto) {
		partnerStatus = injured.familyDto.partnerStatus
	}

	const obj = {
		title: '家庭成员信息',
		key: 'familyDto.familyInfoList', // 提交时对应的字段
		modal: modal, // 每一行的模板
		children: list, // 数据列表
		familyDto: {
			fatherDied: fatherDied,
			motherDied: motherDied,
			noChildren: noChildren,
			noOther: noOther,
			partnerStatus: partnerStatus,
		},
	}

	return obj
}
